<template>
	<div>
		<!-- 子节点界面 -->
		<lcsj-dialog v-model="editFormVisible" :title="'[' + title + ']' + '子节点维护'" @close="closeDialog">
			<el-form :inline="true">
				<el-form-item>
					<!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
				</el-form-item>
			</el-form>
			<!--子节点列表-->
			<STable :columns="columnsData" :data="listData" :loading="loading" table-type="dialog" @get-data="getListData2" @handle-command="handleCommand" @row-click="handleRowClick"></STable>
			<div style="display: flex; align-items: center; justify-content: space-between">
				<Pagination :child-msg="pageparm" @call-father="callFather"></Pagination>
				<el-button size="small" class="back" @click="backDialog">返回</el-button>
			</div>
		</lcsj-dialog>
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetDicDataList } from "../../../api/dicDataApi.js";
import edit from "./edit.vue";
export default {
	data() {
		return {
			name: "child",
			title: "",
			editFormVisible: false, //子节点页面的显示与隐藏
			listData: [], //子节点数据
			preCode: [], //返回
			loading: false,
			// 分页参数
			pageparm: {
				currentPage: 1,
				pageSize: 10,
				total: 10
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				dicText: "",
				dicCode: "",
				parentCode: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "dicCode",
					label: "字典编号",
					minWidth: "260"
				},
				{
					prop: "dicText",
					label: "字典名称",
					minWidth: "260"
				},
				{
					prop: "seq",
					label: "显示顺序",
					minWidth: "120"
				},
				{
					prop: "desc",
					label: "字典描述"
				},
				{
					operation: true,
					isKeep: true,
					label: "操作",
					btnGroup: [
						{
							icon: "el-icon-view",
							name: "查看",
							type: "1"
						},
						{
							icon: "el-icon-plus",
							name: "子节点",
							type: "3",
							btnType: "primary"
						},
						{
							icon: "el-icon-delete",
							name: "删除",
							type: "4",
							btnType: "danger"
						}
					]
				}
			]
		};
	},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.openChildWin(command.rowData);
					break;
				case "3":
					this.addModule(command.rowData);
					break;
				case "4":
					this.deleteData(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		//显示子节点界面
		openChildWin(row) {
			this.formInline.pageIndex = 1;
			this.editFormVisible = true;
			this.title = row.dicText;
			this.formInline.parentCode = row.dicCode;
			// 保存当前行文本值和父code
			this.preCode.push({
				pCode: row.parentCode,
				title: row.dicText
			});
			this.loading = true;
			this.getListData2();
		},
		getListData2() {
			GetDicDataList(this.formInline)
				.then((res) => {
					this.loading = false;
					this.listData = res.data.map((item) => {
						let arr = item.dicCode.split("_");
						item.dicCode_new = arr.reverse()[0];
						return item;
					});
					this.pageparm.total = res.totalNumber;
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.title = "";
			this.$refs.edit.handleEdit(row);
		},
		addModule(row) {
			this.$refs.edit.title = "新增子节点";
			this.$refs.edit.handleEdit(row);
		},
		// 编辑/
		handleEdit(row) {
			this.$refs.edit.title = "";
			this.$refs.edit.handleEdit(row);
		},
		// 删除数据
		deleteData(row) {
			this.$parent.deleteData(row);
		},
		closeDialog() {
			this.preCode = [];
			this.editFormVisible = false;
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData2(this.formInline);
		},
		backDialog() {
			this.formInline.pageIndex = 1;
			if (this.preCode.length === 1) {
				this.closeDialog();
			} else {
				// 父code调列表 文本值作标题名称
				this.formInline.parentCode = this.preCode.pop().pCode;
				this.title = this.preCode.slice(-1)[0].title;
				this.getListData2();
			}
		}
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
	},
	mounted() {},
	components: {
		edit
	}
};
</script>
<style scoped>
/* .back {
	position: absolute;
	bottom: 16px;
	right: 20px;
} */
</style>
